/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoControlCenterModelsLokaliseStringSave
 */
export interface ControlcenterMelcoControlCenterModelsLokaliseStringSave {
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseStringSave
     */
    entity_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseStringSave
     */
    culture_id?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseStringSave
     */
    fields?: { [key: string]: string; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof ControlcenterMelcoControlCenterModelsLokaliseStringSave
     */
    is_changed?: boolean;
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringSaveFromJSON(json: any): ControlcenterMelcoControlCenterModelsLokaliseStringSave {
    return ControlcenterMelcoControlCenterModelsLokaliseStringSaveFromJSONTyped(json, false);
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringSaveFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoControlCenterModelsLokaliseStringSave {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'culture_id': !exists(json, 'culture_id') ? undefined : json['culture_id'],
        'fields': !exists(json, 'fields') ? undefined : json['fields'],
        'is_changed': !exists(json, 'is_changed') ? undefined : json['is_changed'],
    };
}

export function ControlcenterMelcoControlCenterModelsLokaliseStringSaveToJSON(value?: ControlcenterMelcoControlCenterModelsLokaliseStringSave | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'culture_id': value.culture_id,
        'fields': value.fields,
        'is_changed': value.is_changed,
    };
}


